import { render, staticRenderFns } from "./MobileRaiseSetup.vue?vue&type=template&id=dcb3ddec&scoped=true"
import script from "./MobileRaiseSetup.vue?vue&type=script&lang=ts"
export * from "./MobileRaiseSetup.vue?vue&type=script&lang=ts"
import style0 from "./MobileRaiseSetup.vue?vue&type=style&index=0&id=dcb3ddec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3ddec",
  null
  
)

export default component.exports